const secondToMMSS = rawSeconds => {
    rawSeconds = parseInt(Math.round(rawSeconds), 10);

    // Handle negative numbers by returning 00:00
    if (rawSeconds < 0) {
        return '00:00';
    }

    let hours = Math.floor(rawSeconds / 3600);

    let minutes = Math.floor((rawSeconds - hours * 3600) / 60);
    let seconds = rawSeconds - hours * 3600 - minutes * 60;

    if (isNaN(minutes) || isNaN(seconds)) {
        return '00:00';
    }

    if (hours < 10) {
        hours = `0${hours}`;
    }
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    if (seconds < 10) {
        seconds = `0${seconds}`;
    }
    if (hours === '00') {
        return `${minutes}:${seconds}`;
    }
    return `${hours}:${minutes}:${seconds}`;
};

export default secondToMMSS;
